import { useEffect } from 'react';

const LS_KEY = 'vf:builder-surface';
const RESET_PARAM = 'reset-surface';

/**
 * Escape hatch para limpar a preferência sticky de builder surface.
 *
 * Cenário: usuário clica "Usar desktop" em MobileBuilderErrorBoundary após um
 * crash do mobile builder. Isso grava `localStorage['vf:builder-surface'] =
 * 'desktop'` permanentemente. Sem este componente, não havia caminho de
 * retorno via UI — o user precisaria inspecionar localStorage (impossível
 * no Safari iOS sem DevTools).
 *
 * Uso: acessar qualquer rota com `?reset-surface=1` no fim da URL. Limpa o
 * LS e remove o param da URL via replaceState (sem reload, sem polluição
 * de histórico).
 */
export function SurfaceReset(): null {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (params.get(RESET_PARAM) !== '1') return;

    try {
      localStorage.removeItem(LS_KEY);
    } catch {
      // localStorage may be unavailable (private mode); param removal still useful.
    }

    params.delete(RESET_PARAM);
    const search = params.toString();
    const newUrl =
      window.location.pathname + (search ? `?${search}` : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }, []);

  return null;
}
